import { BaseDataService } from './Base/BaseDataService';
import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { SharepointResponse } from '../Models/Sharepoint/Sharepoint';

export const SharepointEndpoints = {
    VERIFY_URL: (url: string) => `/api/v1/back/libraries/urls/${url}`,
};

export interface ISharepointDataService {
    verifySharepoint: (
        requestParams: {
            url: string;
        },
        cts: XHRRequestCanceler
    ) => Promise<SharepointResponse>;
}

class SharepointDataService extends BaseDataService implements ISharepointDataService {
    public verifySharepoint = (
        requestParams: {
            url: string;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<SharepointResponse>(
            SharepointEndpoints.VERIFY_URL(requestParams.url),
            cts,
            { checkError: false }
        );
    };
}

const SharepointDataServiceName = 'SharepointDataService';
export { SharepointDataService, SharepointDataServiceName };
